import React, { useState, useEffect } from 'react'
import { Grid, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { reduxForm, Field } from 'redux-form';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles(theme => ({
    textField: {
        width: 200,
    },
    margin: {
        margin: theme.spacing(1),
    },
}));

const validate = values => {
    const error  = {}
    if (!values.alias) {
        error.alias = "El alias es obligatorio"
    }
    if (!values.agreement) {
        error.agreement = "La operadora es obligatoria"
    }
    if (!values.reference) {
        error.reference = "La referencia es obligatoria."
    }
    return error
}

const ElectronicRechargesFormEditFavorite = props => {

    const { 
        handleSubmit,
        agreements, 
        onCancelAction, 
        titleLabelReference,
        titleLabelAgreement,
        handleChangeAgreementEditFavorite,
        initialValues,
        pristine 
    } = props

    const [ agreementsSelected, setAgreementsSelected ] = useState({
        AgreementForm : [],
        category : "",
        hasIndividualRate : 1,
        name : "",
        rate : "0",
        uuid : "",
        identity : "",
        nameIdentity : ""
    })

    const mount = () => {
        const unmount = () => {
            setAgreementsSelected(initialValues.agreement)
        }
        return unmount()
    }

    useEffect(mount, [])

    const classes = useStyles();

    return (
        <div>
            <Grid container spacing={3}>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <Autocomplete
                        id="combo-box-demo"
                        value={ agreementsSelected }
                        options={agreements}
                        disableClearable
                        getOptionLabel={(option) => (option.name) ? option.name : ""}
                        style={{ width: '100%' }}
                        onChange = { (e, nv) => {
                                        setAgreementsSelected(nv)
                                        handleChangeAgreementEditFavorite(nv)
                                    }}
                        renderInput={(params) => <TextField {...params} label={titleLabelAgreement} variant="outlined" />}
                    />
                </Grid>
            </Grid>
            <form className={classes.form} onSubmit={ handleSubmit }>
                <Grid container spacing={3}>
                    
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Field
                            name="alias"
                            id="alias"
                            autoFocus = { true }
                            component={ RenderTextFieldRedux }
                            label="Alias"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Field
                            name="reference"
                            id="reference"
                            component={ RenderTextFieldRedux }
                            label= {titleLabelReference}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6} md={6} lg={6} xl={6}>
                        <Button variant="contained" type="submit"
                            fullWidth
                            color="primary"
                            disabled={pristine }
                            >
                            Actualizar
                        </Button>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6} xl={6}>
                        <Button variant="contained" fullWidth
                            color="primary" onClick = { () => onCancelAction() }>
                            Cancelar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </div>
    )
}

const ElectronicRechargesFormEditFavoriteReduxForm = reduxForm(
    {
        form: 'ElectronicRechargesFormEditFavorite',
        validate
    }
)(ElectronicRechargesFormEditFavorite)
export default ElectronicRechargesFormEditFavoriteReduxForm
